[
 {
  "id": "row",
  "x": 80,
  "y": 620,
  "w": 780,
  "h": 134
 },
 {
  "id": "tab.friends",
  "x": 110,
  "y": 440,
  "w": 360,
  "h": 130
 },
 {
  "id": "tab.requests",
  "x": 480,
  "y": 440,
  "w": 360,
  "h": 130
 },
 {
  "id": "badge",
  "x": 750,
  "y": 430,
  "w": 100,
  "h": 90
 },
 {
  "id": "cta",
  "x": 120,
  "y": 1250,
  "w": 710,
  "h": 130
 }
]
